import AutomaticMessageModal from './AutomaticMessageModal.component';

export default AutomaticMessageModal;